import React, { CSSProperties } from "react";
import { Box, Icons } from "fds";
import classNames from "classnames";
interface WorkgroupManagerIconProps {
  classes?: string;
  style?: CSSProperties;
}
const WorkgroupManagerIcon: React.FC<WorkgroupManagerIconProps> = ({
  classes,
  style,
}) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      style={style}
      className={classNames("workgroupManager", classes)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="7"
        fill="#FCAF5C"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M6.44482 7.36861L7.5271 5.20406C7.72043 4.8174 8.27221 4.8174 8.46554 5.20406L9.54782 7.36861C9.69535 7.66369 10.0754 7.75096 10.3369 7.54981L11.7004 6.501C12.1251 6.17429 12.7086 6.6195 12.5058 7.11545L11.1484 10.4335C10.987 10.8279 10.6033 11.0855 10.1773 11.0855H5.81538C5.38934 11.0855 5.00559 10.8279 4.84428 10.4335L3.48688 7.11544C3.28399 6.6195 3.86756 6.17429 4.29228 6.501L5.65574 7.54981C5.91723 7.75096 6.29728 7.66369 6.44482 7.36861Z"
        fill="white"
      />
    </svg>
  );
};
export default WorkgroupManagerIcon;
